module.exports = __webpack_public_path__ + "static/media/garvin_paywall.dc02e8.781d9f12.png";